import { useTranslator } from '@bluebeam/react-i18n';
import { useAuth } from 'auth';
import { Button } from 'components/lib';
import PostRFISelectModal from 'components/modals/PostRFISelectModal';
import SelectVisibleLayersModal from 'components/modals/SelectVisibleLayersModal';
import AppStoreContext from 'contexts/AppStoreContext';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';
import React, { useContext } from 'react';
import { ModalState } from 'records/ModalState';

type Props = {
  pageid: string;
  sheetid: string;
};

const PlaceRFIBtn: React.FC<Props> = (props: Props) => {
  const { userId } = useAuth();
  const { pageid, sheetid } = props;
  const { state: appState, actions } = useContext(AppStoreContext);
  const { translate } = useTranslator(['mapView']);
  const { [FeatureFlag.AddRfiToDrawing]: isAddRfiToDrawingEnabled } =
    useFeatureFlags();

  function handlePostRFIClick() {
    actions.clearInteractions();

    let modalState;
    if (
      appState.visibleMappedSheetVersions.size === 1 ||
      !window.location.pathname.includes('/map')
    ) {
      modalState = new ModalState({
        id: 'PostRFISelectModal',
        portal: 'main',
        open: true,
        component: PostRFISelectModal,
        props: {
          sheetid,
          pageid,
        },
      });
    } else {
      modalState = new ModalState({
        id: 'SelectVisibleLayersModal',
        portal: 'main',
        open: true,
        component: SelectVisibleLayersModal,
        props: {
          onLayerSelect: (_sheetid: string, _pageid: string) => {
            const _modalState = new ModalState({
              id: 'PostRFISelectModal',
              portal: 'main',
              open: true,
              component: PostRFISelectModal,
              props: {
                sheetid: _sheetid,
                pageid: _pageid,
              },
            });

            actions.createModal(_modalState);
          },
        },
      });
    }

    actions.createModal(modalState);
  }

  const role = appState.getUserRole(userId);
  const isAdmin = role === 'admin';
  const project = appState.getProject();
  const isTrialExpired =
    project.Status.includes('Trial') && project.trialDaysRemaining === 0;
  const isProjectActive = project.permissions.activeProject;

  return isAdmin &&
    !isTrialExpired &&
    isProjectActive &&
    isAddRfiToDrawingEnabled ? (
    <Button
      data-testid="place-rfi-btn"
      variant="primary"
      id="map-rfi-create"
      size="large"
      style={{ pointerEvents: 'auto' }}
      onClick={handlePostRFIClick}
    >
      {translate('mapView:buttons.postRFI')}
    </Button>
  ) : null;
};

export default PlaceRFIBtn;
